import { FC } from "react";
import { IEsimZoneCountryOption } from "../../../interfaces/esim/EsimZone.types";
import { eurPerGb } from "../../../utils/esim/margin";
import { WithTip } from "../../ui/InfoTip";
import Checkbox from "../../ui/input/Checkbox";

interface Props {
  options: IEsimZoneCountryOption[];
  loading: boolean;
  failed: boolean;
  unticked: Set<number>;
  // TADIG to the reason OCS gave for refusing it on the last attempt.
  refused: Map<string, string>;
  onToggleNetwork: (networkId: number) => void;
}

const NO_NETWORK =
  "Tarifa jonë nuk ka asnjë rrjet këtu, ose emri i shtetit nuk përputhet me OCS. Hiqe nga zona.";

// One card per chosen country with the networks of our tariff there, all ticked to begin with. Nothing
// shared lists networks: they come from OCS, with what a GB costs us on each.
const NetworkPicker: FC<Props> = ({ options, loading, failed, unticked, refused, onToggleNetwork }) => {
  const tadigCount = options.flatMap((c) =>
    c.networks.filter((n) => !unticked.has(n.networkId)).flatMap((n) => n.tadigs)
  ).length;

  return (
    <div className="mb-4">
      <p className="text-sm mb-2">Rrjetet ({tadigCount} TADIG)</p>
      {loading && <p className="text-sm text-neutral">Po lexohet tarifa nga OCS...</p>}
      {failed && <p className="text-sm text-red">Tarifa nuk u lexua nga OCS. Provo përsëri.</p>}
      <div className="space-y-3">
        {options.map((c) => (
          <div key={c.countryId} className="bg-gray-50 rounded-lg p-3">
            <p className="font-medium text-sm mb-2">
              {c.countryName} <span className="text-neutral text-xs">{c.countryIso2 ?? ""}</span>
            </p>
            {c.networks.length === 0 && (
              <p className="text-xs text-red">
                <WithTip label="Asnjë rrjet" tip={NO_NETWORK} tone="warning" />
              </p>
            )}
            {c.networks.map((n) => {
              const refusal = n.tadigs.map((t) => refused.get(t)).find(Boolean);
              return (
                <div key={n.networkId} className="flex items-center gap-3 py-1">
                  <Checkbox
                    id={`network-${n.networkId}`}
                    label={n.operatorName ?? "–"}
                    checked={!unticked.has(n.networkId)}
                    onChange={() => onToggleNetwork(n.networkId)}
                  />
                  <span className="text-xs text-neutral">{n.tadigs.join(", ")}</span>
                  <span className="text-xs text-neutral ml-auto">{eurPerGb(n.costPerGb)}</span>
                  {refusal && <span className="text-xs text-red">OCS: {refusal}</span>}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NetworkPicker;
